import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemText,
    ListItem,
    List,
    Typography
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { IconTrash } from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import { useOrganogramContext } from '../hooks/useOrganogramContext';

export function NodeModal() {
    const {
        selectedNode,
        isModalOpen,
        handleSaveNode,
        onDeleteNode,
        closeModal,
        agencies,
        fetchAgencyDetails,
        isViewMode,
        isLoadingDetails
    } = useOrganogramContext();
    const [formData, setFormData] = useState(selectedNode);

    useEffect(() => {
        if (!selectedNode?.agency) {
            setFormData(null);
            return;
        }

        fetchAgencyDetails(selectedNode.agency).then((details) => {
            const [selectedAgency] = details;

            setFormData({
                agency: selectedNode.agency,
                description: selectedAgency?.description || '',
                principalsInfo: selectedAgency
                    ? selectedAgency?.principals.map((p) => ({
                          id: p.id,
                          name: p.name,
                          roleName: p.role?.name,
                          roleDescription: p.role?.description
                      }))
                    : []
            });
        });

        return () => setFormData(null);
    }, [selectedNode]);

    

    return (
        <Dialog open={isModalOpen} onClose={closeModal} maxWidth="xl" fullWidth>
            <DialogTitle>Editar {selectedNode?.title}</DialogTitle>

            <DialogContent>
                {isLoadingDetails ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            py: 1
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                py: 1
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="members-label">
                                    Agência
                                </InputLabel>
                                <Select
                                    disabled={isViewMode}
                                    labelId="agencies-label"
                                    id="agencies-select"
                                    value={formData?.agency || []}
                                    onChange={async (e) => {
                                        const [findAgency] =
                                            await fetchAgencyDetails(
                                                e.target.value
                                            );

                                        setFormData((prev) => ({
                                            ...prev,
                                            agency: e.target.value,
                                            description:
                                                findAgency?.description || '',
                                            principalsInfo: findAgency
                                                ? findAgency.principals.map(
                                                      (p) => ({
                                                          id: p.id,
                                                          name: p.name,
                                                          roleName:
                                                              p.role?.name,
                                                          roleDescription:
                                                              p.role
                                                                  ?.description
                                                      })
                                                  )
                                                : []
                                        }));
                                    }}
                                    label="Agências"
                                >
                                    {agencies.map((agency) => (
                                        <MenuItem
                                            key={agency.id}
                                            value={agency.id}
                                        >
                                            {agency.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {formData?.agency && (
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    value={formData?.description}
                                    rows={20}
                                    disabled
                                    sx={{
                                        '& .MuiInputBase-input.Mui-disabled': {
                                            WebkitTextFillColor:
                                                'rgba(0, 0, 0, 0.87)',
                                            color: 'rgba(0, 0, 0, 0.87)'
                                        }
                                    }}
                                />
                            )}
                        </Box>
                        {formData?.principalsInfo &&
                            formData.principalsInfo.length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        sx={{ mb: 1 }}
                                    >
                                        Dirigentes
                                    </Typography>
                                    <List>
                                        {formData.principalsInfo.map((p) => (
                                            <ListItem
                                                key={p.id}
                                                disableGutters
                                                sx={{
                                                    mb: 1,
                                                    p: 1,
                                                    border: '1px solid #ccc',
                                                    borderRadius: 1
                                                }}
                                            >
                                                <ListItemText
                                                    primary={
                                                        <Typography
                                                            variant="subtitle1"
                                                            fontWeight="bold"
                                                        >
                                                            {p.name}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <>
                                                            <Typography
                                                                component="span"
                                                                variant="body2"
                                                                color="text.primary"
                                                            >
                                                                {p.roleName}
                                                            </Typography>
                                                            <br />
                                                            <Typography
                                                                component="span"
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                {
                                                                    p.roleDescription
                                                                }
                                                            </Typography>
                                                        </>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            )}
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button variant="contained" onClick={closeModal}>
                    Fechar
                </Button>
                {isViewMode ? null : (
                    <>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => onDeleteNode()}
                        >
                            <IconTrash />
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                const selectedAgency = agencies.find(
                                    (a) => a.id === formData.agency
                                );

                                if (!selectedAgency) return;

                                handleSaveNode({
                                    agency: formData.agency,
                                    members: formData.principalsInfo.map(
                                        (p) => p.id
                                    ),
                                    title: selectedAgency.name
                                });
                            }}
                        >
                            Salvar
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}